import { render } from "./CreateTransfer.vue?vue&type=template&id=3887f806&scoped=true"
import script from "./CreateTransfer.vue?vue&type=script&lang=js"
export * from "./CreateTransfer.vue?vue&type=script&lang=js"

import "./CreateTransfer.vue?vue&type=style&index=0&id=3887f806&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3887f806"]])

export default __exports__